import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getReportsCategoriesList } from './action';
import { Page, Separator, BottomBar } from '../../components/containers';
import { Headline } from '../../components/text';
import ReportsHistory from './History';
import ReportsHistoryManageBar from './HistoryManageBar';
import s from './index.css';
import { getHistoryManageModeIsOn } from '../../selectors';
import { CSSTransitionGroup } from 'react-transition-group';
import { Button } from '../../components/actions';

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({
    dispatch,
    getReportsCategoriesList: bindActionCreators(getReportsCategoriesList, dispatch),
});

class ReportsPage extends React.Component {
    componentWillMount() {
        this.props.getReportsCategoriesList();
    }

    render() {
        return (
            <Fragment>
                <Page>
                    <Separator type="wide" />

                    <ReportsHistory />

                    <Separator type="huge" />
                </Page>

                <ReportsHistoryManageBar />
            </Fragment>
        );
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ReportsPage);



// WEBPACK FOOTER //
// ./app/web/src/container/ReportsPage/index.jsx